/* global google */
import { ReactNode, createContext, useContext } from 'react';
import ReactGoogleMapLoader from 'react-google-maps-loader';

type GoogleMaps = typeof google.maps;

const GoogleMapsContext = createContext<GoogleMaps | undefined>(undefined);

interface GoogleMapsProviderProps {
  children: ReactNode;
}

const params = {
  key: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  libraries: 'places',
};

export function GoogleMapsProvider({ children }: GoogleMapsProviderProps) {
  return (
    <ReactGoogleMapLoader
      params={params}
      render={googleMaps => {
        return (
          <GoogleMapsContext.Provider value={googleMaps}>{children}</GoogleMapsContext.Provider>
        );
      }}
    />
  );
}

export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}
